export const INDICATOR_TEMPLATE_STATUS = {
    ARCHIVED: 'archived',
    DEPLOYED: 'deployed',
    DRAFT: 'draft',
} as const;

export type IndicatorTemplateStatusT =
    (typeof INDICATOR_TEMPLATE_STATUS)[keyof typeof INDICATOR_TEMPLATE_STATUS];

type ChartTemplateBaseT = {
    authorizedFunctions: string[];
    authorizedSoftwares: string[];
    status: IndicatorTemplateStatusT;
    title: string;
};

export type ChartTemplateTableItemT = ChartTemplateBaseT & {
    key: number;
    createdAt: Date;
};

export type CreateChartTemplateDataT = ChartTemplateBaseT & {
    description: string;
    preview: string;
    rootUrl: string;
};

export type EditChartTemplateDataT = {
    newChartTemplateData: CreateChartTemplateDataT;
    shouldUpdateSourceChartParams: boolean;
};
